/**
 * 图片压缩工具类
 */
export class ImageCompressor {
  /**
   * 压缩图片并返回base64
   * @param {string} base64 原始base64字符串
   * @param {Object} options 压缩选项
   * @param {number} options.maxWidth 最大宽度
   * @param {number} options.maxHeight 最大高度
   * @param {number} options.quality 压缩质量(0-1)
   * @returns {Promise<string>} 压缩后的base64字符串
   */
  static async compress(base64, options = {}) {
    const {
      maxWidth = 600,
      maxHeight = 600,
      quality = 0.8
    } = options;

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64;

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // 计算缩放比例
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width *= ratio;
          height *= ratio;
        }

        // 创建canvas
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        // 绘制图片
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // 转换为压缩后的base64
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(compressedBase64);
      };

      img.onerror = reject;
    });
  }

  /**
   * 解压base64图片
   * @param {string} compressedBase64 压缩后的base64字符串
   * @returns {Promise<string>} 解压后的base64字符串
   */
  static async decompress(compressedBase64) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = compressedBase64;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        // 转换为原始质量的base64
        const decompressedBase64 = canvas.toDataURL('image/jpeg', 1.0);
        resolve(decompressedBase64);
      };

      img.onerror = reject;
    });
  }
}